import { AjsCatalogEditorModalComponent } from "./components/catalog-editor-modal.component.js";
import { AjsCatalogItemViewerModalComponent } from "./components/catalog-item-viewer.component.js";
import { AjsCatalogViewerModalComponent } from "./components/catalog-viewer-modal.component.js";
import { ObjectSolverByUuid }  from '../../../js/services/ObjectSolverService.js';
import { ContentCatalog, ContentCatalogItem } from "./content-catalog.js";

export class CatalogsService {

    static name = "catalogsService";

    static $inject = [ "gameSceneService", "$userAssets", "$injector" ];

    $injector;

    constructor(
        gameSceneService,
        artestUserAssets,
        $injector
    ) {
        this.gameSceneService = gameSceneService;
        this.artestUserAssets = artestUserAssets;
        this.$injector = $injector;
    }

    openCatalogItemViewer( item, catalog, arrangement ) {

        if (document.querySelector(".modal.modal-catalog-item-viewer")) return console.warn( "Modal already open" );

        this.$injector.get("$uibModal").open( AjsCatalogItemViewerModalComponent.asUibModal({ item, catalog, arrangement }) );
    }

    openCatalogViewer( arrangement = this.solveCurrentArrangement(), catalog = this.solveCurrentCatalog( this.solveCatalogs( arrangement )) ) {

        if (document.querySelector(".modal.modal-catalog-viewer-modal")) return console.warn( "Modal already open" );

        if (!catalog) catalog = null;

        this.$injector.get("$uibModal").open( AjsCatalogViewerModalComponent.asUibModal({ arrangement, catalog }) );
    }

    openCatalogEditor( catalog, arrangement = this.solveCurrentArrangement() ) {

        if (document.querySelector(".modal.modal-catalog-editor-modal")) return console.warn( "Modal already open" );

        this.$injector.get("$uibModal").open( AjsCatalogEditorModalComponent.asUibModal({ catalog, arrangement }) );
    }

    createCatalog( arrangement = this.solveCurrentArrangement(), catalog = ContentCatalog.fromArrangement( arrangement ) ) {

        if (arrangement) {
            this.pushCatalog( arrangement, catalog )
        };

        return catalog;
    }

    pushCatalog( arrangement, catalog ) {

        if (arrangement.catalogs && arrangement.catalogs.length > 0) {
            arrangement.catalogs.push( catalog );
        } else {
            arrangement.catalogs = [ catalog ];
        }
    }

    removeCatalog( catalog, arrangement ) {

        if (arrangement.catalogs && arrangement.catalogs.length > 0) {

            let catalog_idx = arrangement.catalogs.indexOf( catalog ); 

            if (catalog_idx != -1) {
                arrangement.catalogs.splice( catalog_idx, 1 );
            }
        } else {
            arrangement.catalogs = [];
        }
    }

    solveCurrentArrangement() {

        if (this.gameSceneService.arrangement) {
            return this.gameSceneService.arrangement;
        }
    }
    
    solveCatalogs( arrangement ) {

        if (arrangement) {
            if (arrangement.catalogs && arrangement.catalogs.length > 0) {
                return [ ...arrangement.catalogs ];
            }
        }

        return [];
    }

    solveCurrentCatalog( catalogs ) {

        if (catalogs) {

            let idx = this.solveCurrentCatalogIdx( catalogs );

            if (catalogs[ idx ]) {
                return catalogs[ idx ];
            } else if (catalogs[ 0 ]) {
                return catalogs[ 0 ];
            }
        }
    }

    solveCurrentCatalogIdx( catalogs ) {
        return 0;

        /* if (catalogs) {

            if (typeof this.catalog_idx == "number" && catalogs[ this.catalog_idx ]) return this.catalog_idx;

            if (typeof this.arrangement.default_catalog_idx == "number" && catalogs[ this.arrangement.default_catalog_idx ]) return this.arrangement.default_catalog_idx;

            return 0;
        } */
    }

    getCurrentCatalogItemsByType( type, catalog = this.solveCurrentCatalog( this.solveCatalogs( this.solveCurrentArrangement())) ) {

        if (catalog) {
            return catalog.solveItemsByType( type );
        }
    }

    getItemHeading( item ) {

        if (item.heading) return item.heading;

        let result = this.getClientOeuvreItem( item );

        if (result) {

            // TODO: Lisää {{ oeuvre.with.client_artist.name }} ja {{ oeuvre.with.client_artist.badge }}

            if (!result.heading) {
                result.heading = this.$injector.get( "artestOeuvreFilter" )( result.client_oeuvre );
            }

            return result.heading;
        }
    }

    getItemDescription( item ) {

        if (item.description) return item.description;

        let result = this.getClientOeuvreItem( item );

        if (result) {
            if (!result.description) {

                result.description = "";

                if (result.client_oeuvre && result.client_oeuvre.with && result.client_oeuvre.with.oeuvre) {
                    result.description = result.client_oeuvre.with.oeuvre.description;
                }
            }

            return result.description;
        }
    }

    getItemMediaSrc( item, size = null ) {
        // @TODO: Käytä mahdollisesti item.media'aan asetettua kuvalähdettä!

        let result = this.getClientOeuvreItem( item );

        if (result) {

			switch (size) {
				case "large":
					size = "large";
					break;
				case "normal":
					size = "normal";
					break;
				default:
					size = null;
			}

			if (size) {

				if (result.client_oeuvre && result.client_oeuvre.with && result.client_oeuvre.with.oeuvre && result.client_oeuvre.with.oeuvre.img_uid) {
                    return `/i/${ result.client_oeuvre.with.oeuvre.img_uid }?size=${ size }`;
                }

			} else if (!result.media_src) {

                if (result.client_oeuvre && result.client_oeuvre.with && result.client_oeuvre.with.oeuvre && result.client_oeuvre.with.oeuvre.img_uid) {
                    result.media_src = `/i/${ result.client_oeuvre.with.oeuvre.img_uid }?size=normal`;
                }
            }

            return result.media_src;
        }
    }

    client_oeuvre_item_cache = {};

    getClientOeuvreItem( item ) {

        let result = this.getClientOeuvreItemAsync( item );

        if (result.client_oeuvre) return result;
    }

    getClientOeuvreItemAsync( item ) {

        let { type, uid } = item;

        if (type != 'client_oeuvre') return;

        if (!this.client_oeuvre_item_cache[ uid ]) {

            // TODO: vaihda käyttöön getClientOeuvreSingles
            this.client_oeuvre_item_cache[ uid ] = this.artestUserAssets.getClientsOeuvresRaw([ uid ]).then( results => {

                //let object = this.

                this.client_oeuvre_item_cache[ uid ] = {
                    client_oeuvre: results[ uid ]
                };
            });
        }
        
        return this.client_oeuvre_item_cache[ uid ];
    }

    /**
     * 
     * @param {any} object 
     * @param {ContentCatalog} catalog 
     * @returns (null|ContentCatalogItem)
     */
    solveCatalogItemByObject( object, catalog = this.solveCurrentCatalog( this.solveCatalogs( this.solveCurrentArrangement( )))) {

        if (catalog) {
            return catalog.solveItemByObject( object );
        }
        
        return null;
    }

    /**
     * 
     * @param {ContentCatalogItem} catalog_item 
     * @param {ContentCatalog} catalog 
     * @returns (null|any)
     */
    solveObjectByCatalogItem( catalog_item, catalog = this.solveCurrentCatalog( this.solveCatalogs( this.solveCurrentArrangement( ))) ) {

        // TODO

        return null;
    }

    /**
     * 
     * @param {ContentCatalogItem} item 
     * @returns null|Oeuvre|Mesh
     */
    solveItemObject( item ) {
        try {

            if (item.type == 'client_oeuvre') {
                return ObjectSolverByUuid( item.uid, 'oeuvre' );
            }

        } catch (error) {}

        return null;
    }

    /**
     * @param {ContentCatalogItem} item 
     * @returns boolean
     */
    adjustPlayerToLookItem( item ) {
        try {

            let object = this.solveItemObject( item );

            if (object) {

                if (item.type == 'client_oeuvre') {

                    this.gameSceneService.player.adjustToLookPainting( object );

                } else {

                    this.gameSceneService.player.adjustToLookMesh( object.mesh );

                }

                return true;

            }
        } catch (error) {
            console.error( error );
        }

        return false;
    }
}

export const AjsCatalogsService = CatalogsService;
